import { useReferralStore } from '~/stores/referral'

export default function () {
  const route = useRoute()
  if (!route.query) return

  const referralStore = useReferralStore()

  const isReferral = !!route.query.utm_source || !!route.query.utm_medium

  const isMetaFlow = isReferral && !route.query.airport && referralStore.isPlatformKnown
  referralStore.$patch({ isMetaFlow })
  referralStore.$patch({
    leadGenerator: route.query?.utm_source as string,
    partnerBookingId: route.query?.partnerBookingId as string,
    leadPlatform: route.query?.utm_medium as string,
  })
}
